import React from 'react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { ServicesSection } from '../components/ServicesSection';
import { Specialization } from '../components/Specialization';
import { Process } from '../components/Process';
import { ConsultationCTA } from '../components/ConsultationCTA';
import { Newsletter } from '../components/Newsletter';
export function ServicesPage() {
  return <>
      <Seo title="Services — Brand Identity, Logo & Packaging Design | Morvix Graphics" description="Brand identity, logo design, packaging, brand guidelines, motion graphics, UI and web design. Morvix Graphics builds visual systems for ambitious brands worldwide." path="/services" data-id="element-727" data-mp="2c7ufdqwjl0lf" />
      <PageHeader eyebrow="Services" title="Everything a brand|needs to be seen" lead="From identity to execution, we create visual systems that help businesses communicate with clarity and confidence — sixteen disciplines, one consistent standard." data-id="element-728" data-mp="2q1lo4x2g8gg3" />
      <ServicesSection data-id="element-729" data-mp="2xllyxb0vpq3w" />
      <Specialization data-id="element-730" data-mp="2xhohquxv38mn" />
      <Process data-id="element-731" data-mp="2skeu9ku1971g" />
      <ConsultationCTA data-id="element-732" data-mp="2skoip3zfj651" />
      <Newsletter data-id="element-733" data-mp="2sjd7ij3nmw3w" />
    </>;
}